export const useOrganizationStore = defineStore("organization", () => {
  const getCurrentOrganizationFetch = useGetCurrentOrganization();
  const currentOrganization = computed(
    () =>
      unref(getCurrentOrganizationFetch.data) as OrganizationInfo | undefined,
  );
  const isOrganizationResolved = computed(() =>
    unref(getCurrentOrganizationFetch.resolved),
  );
  const isOrganizationRejected = computed(() =>
    unref(getCurrentOrganizationFetch.rejected),
  );
  const isLoadingOrganization = computed(() =>
    unref(getCurrentOrganizationFetch.pending),
  );

  function refreshCurrentOrganization() {
    return getCurrentOrganizationFetch.safeFetch();
  }

  function resetCurrentOrganization() {
    return getCurrentOrganizationFetch.reset();
  }

  return {
    isLoadingOrganization,
    isOrganizationResolved,
    isOrganizationRejected,
    currentOrganization,
    refreshCurrentOrganization,
    resetCurrentOrganization,
  };
});
